import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { PaymentPageRightSidePanelType } from 'src/types';

export interface PaymentPageRightSidePanelState {
  activePanelView: PaymentPageRightSidePanelType | null;
}

const initialState = {
  activePanelView: null,
} as PaymentPageRightSidePanelState;

export const paymentPageRightSidePanelSlice = createSlice({
  name: 'paymentPageRightSidePanel',
  initialState,
  reducers: {
    setActivePanelView: (
      state,
      { payload }: PayloadAction<PaymentPageRightSidePanelType | null>,
    ) => {
      state.activePanelView = payload;
    },
  },
});

export const paymentPageRightSidePanelState = (state: RootState) =>
  state.paymentPageRightSidePanel as PaymentPageRightSidePanelState;

export const { setActivePanelView } = paymentPageRightSidePanelSlice.actions;

export default paymentPageRightSidePanelSlice.reducer;
